module.controller(
    'TechniqueListCtrl',
    [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService','analysisService', 'regulationService',
        function($scope, $rootScope, $state, regulationService, alertService, analysisService, regulationService) {
    	
    	
		$scope.operationType = $state.current.data.type;
		var isUpdate = $scope.operationType == 'update';
    		$scope.idAnalysis = $state.params.idAnalysis;
    		$scope.idTechnique = $state.params.idTechnique;
            $scope.techniques = [];
            $scope.loading = false;
            $scope.filter = {};
            $scope.pagination = {
                    current : 1,
                    total : 0
                };


            $scope.search = function(page) {
                $scope.loading = true;
                
                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;
            

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                analysisService.searchTechniques(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.techniques = result;
                    $scope.pagination.total = result.length;
                }, function(response) {
                    $scope.loading = false;
                });
            };
            
        	$scope.sendAction = function() {
        			if ($scope.operationType == 'create') {
        				$scope.create();
        			} else {
        				$scope.update();
        			}	
   
        	};   
        	/**
        	 * 
        	 */
        	$scope.create = function() {
        		alertService.showSwtQuestion('Crear Técnica', function() {
        			$scope.loading = true;

        			var createModel = {
        				name : $scope.technique.name,
        				description : $scope.technique.description,
        				sigla : $scope.technique.sigla,
        			};
        			analysisService.createTechnique(createModel).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Técnica creada satisfactoriamente');
        				var id = response.getData().id;
        				$state.go('home.TechniqueList');
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
        	};
        	
        	/**
        	 * 
        	 */
        	
        	$scope.update = function() {
        		alertService.showSwtQuestion('Actualizar Técnica', function() {
        			$scope.loading = true;

        			var createModel = {
        				name : $scope.technique.name,
        				description : $scope.technique.description,
        				sigla : $scope.technique.sigla,
        			};
        			analysisService.updateTechnique($scope.idTechnique,createModel).then(function(response) {
        				$scope.loading = false;
        				alertService.showSuccess('Técnica actualizada satisfactoriamente');
        				$state.go('home.TechniqueList');
        			}, function(response) {
        				$scope.loading = false;
        			});
        		});
        	};
        	
        	$scope.load = function(idTechnique) {

        		$scope.loading = true;

        		analysisService.getTechnique(idTechnique).then(function(response) {
        			$scope.loading = false;

        			var responseData = response.getData();
        			$scope.technique = {
        				name : responseData.name,
        				description : responseData.description,
        				sigla : responseData.sigla,
        				samplingMethods : responseData.samplingMethods,
        			};

        		}, function(response) {
        			$scope.loading = false;
        		});
        	};
            

            
            $scope.clearFilters = function(){
            	$scope.filter = {};
            };
            $scope.search(1);
            
            if (isUpdate) {
        		$scope.load($scope.idTechnique);
        	}
            
        	$scope.addSamplingMethod = function() {
        		$scope.loadingSM = true;
        		$scope.inserted = {
        			id : -1,
        			name : ''
        		};
        		$scope.technique.samplingMethods.push($scope.inserted);
        	};
        	
        	$scope.saveSamplingMethod = function(name, idx, sm) {
        		$scope.loadingSM = true;
        		var model = name;
        		if (sm.id == -1) {
        			analysisService.addTechniqueSamplingMethod($scope.idTechnique, model).then(function(response) {
        				$scope.loadingSM = false;
        				sm.id = response.getData().id;
        				alertService.showSuccess('Método ' + sm.name + ' adicionado satisfactoriamente');
        			}, function(response) {
        				$scope.technique.samplingMethods.splice(idx, 1);
        				$scope.loadingSM = false;
        			});
        		} else {
        			var lastVal = sm;
        			analysisService.updateTechniqueSamplingMethod($scope.idTechnique, sm.id, model).then(
    					function(response) {
    						$scope.loadingSM = false;
    						alertService.showSuccess('Método ' + sm.name + ' actualizado satisfactoriamente');
    					}, function(response) {
    						sm = lastVal;
    						$scope.loadingSM = false;
					});
        		}
        	}
        	
        	$scope.removeSamplingMethod = function(sm) {
        		$scope.loadingSM = true;
        		analysisService.removeTechniqueSamplingMethod($scope.idTechnique, sm.id).then(function(response) {
        			$scope.loadingSM = false;
        			var idx = findIndex($scope.technique.samplingMethods, sm.id);
        			if (idx > -1)
        				$scope.technique.samplingMethods.splice(idx, 1);
        			alertService.showSuccess('Método ' + sm.name + ' eliminado satisfactoriamente');
        		}, function(response) {
        			$scope.loadingSM = false;
        		});
        	}
        	
        	function findIndex(array, id) {
        		return array.findIndex(function(a) {
        			return a.id == id;
        		})
        	}
        	
        	$scope.changeTechniqueState = function(idTechnique, state){
            	if(state){
            		regulationService.enableTechnique(0, 0, idTechnique).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Técnica activa nuevamente en el sistema');
            		}, function(response) {
            			
            			$scope.loading = false;	
            		}); 
            	}
            	else{
            		regulationService.disableTechnique(0, 0, idTechnique).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Técnica inactiva');
            		}, function(response) {
            			$scope.search(1);
            			$scope.loading = true;	
            		}); 
            	}
            };
            
            $scope.remove= function(idRegulation, idAnalysis, idTechnique){
            	var technique = $scope.techniques.find(function(m){ return m.id == idTechnique; })
                alertService.showSwtQuestion('Eliminar Técnica "'+ technique.name +'"', function() {
                    $scope.loading = true;

                    regulationService.removeTechnique(idRegulation,idAnalysis,idTechnique).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Técnica eliminada satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };
        	
            
        } ]);


